import { Component } from '@angular/core';
import { NotificationDto, NotificationModel, NotificationType } from '@sestek/notification';
import { ToasterService } from '@abp/ng.theme.shared';
import { LocalizationService } from '@abp/ng.core';
import { ConversationExportFailedNotificationModel } from '../models/conversation-export-failed-notification-model';

@Component({
  selector: 'cai-conversation-export-failed-notification',
  templateUrl: './conversation-export-failed-notification.component.html',
  styleUrls: ['./conversation-export-failed-notification.component.scss'],
  standalone: false,
})
@NotificationType('ConversationExportFailedNotification')
export class ConversationExportFailedNotificationComponent {
  _data: NotificationDto;

  get data() {
    return this._data;
  }
  set data(data: NotificationDto) {
    this._data = data;
    this.notification = JSON.parse(data.payload);
  }

  notification: ConversationExportFailedNotificationModel;

  constructor(
    private localizationService: LocalizationService,
    private toasterService: ToasterService,
  ) {}

  showNotification(notification: NotificationModel) {
    this.notification = JSON.parse(notification.payload);

    const message = this.localizationService.instant('Conversation::ReportCreationFailedMessage');

    this.toasterService.error(message);
  }
}
